exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.title[data-v-d247056c] {\n  padding: 0.5rem 0 0.4rem 0;\n}\n.cont[data-v-d247056c] {\n  line-height: 0.9rem;\n}", ""]);

// exports
